import React, { useContext } from 'react';
import { enrollmentContext } from '../../../../../hoc/context/enrollment/enrollment-context';
import ReviewGroup from '../item/item-group';
import { formatPhoneNumber } from '../../../../../hoc/components/inputs/common-functions';
import context from '../../../../../hoc/context/product/context';
import { FormConstants } from '../../../../../hoc/constants/form.constants';
import { PerformerConstants } from '../../../../../hoc/constants/performer.constants';
import PersonalInfo from '../personal-info/personal-info';
import { RichText } from '../../../../../hoc/components';

const ContactInfo: React.FC<{}> = () => {
	const ctxt = useContext(context);
	const enrollmentCtxt = useContext(enrollmentContext);

	// Data structure to be shown
	const data = [];
	let suffix = '';
	let separator = ' ';
	if (
		ctxt.json.getForm('caregiverDetails') &&
		enrollmentCtxt.input.performer === PerformerConstants.caregiver &&
		!enrollmentCtxt.getFormField('checkedSameAddress')?.value
	) {
		suffix = 'caregiver';
	}

	if (enrollmentCtxt.getFormField('apt' + suffix)?.value) {
		separator = ', ';
	}
	data.push({
		label: ctxt.json.pages.review.enrollmentMail,
		value:
			'<p>' +
			enrollmentCtxt.getFormField('mail' + suffix)?.value +
			separator +
			enrollmentCtxt.getFormField('apt' + suffix)?.value +
			'</p><p>' +
			enrollmentCtxt.getFormField('city' + suffix)?.value +
			', ' +
			enrollmentCtxt.getFormField('state' + suffix)?.value +
			' ' +
			enrollmentCtxt.getFormField('zip' + suffix)?.value +
			'</p>',
	});
	if (enrollmentCtxt.getFormField('email')?.value) {
		data.push({
			label: ctxt.json.pages.userProfile.servicefieldEmailLabel,
			value: enrollmentCtxt.getFormField('email')?.value,
		});
	}
	data.push({
		label:
			enrollmentCtxt.getFormField('phoneusage')?.value ===
			FormConstants.phoneUsageHome
				? ctxt.json.pages.review.enrollment_phone
				: ctxt.json.pages.review.enrollment_mobile,
		value: formatPhoneNumber(
			enrollmentCtxt.getFormField('phone')?.value as string
		),
	});
	if (
		enrollmentCtxt.getFormField('phoneusage')?.value ===
			FormConstants.phoneUsageHome &&
		enrollmentCtxt.getFormField('mobile')?.value
	) {
		data.push({
			label: ctxt.json.pages.review.enrollmentMobile,
			value: formatPhoneNumber(enrollmentCtxt.getFormField('mobile')?.value),
		});
	}

	return (
		<div>
			{ctxt.json.getForm('caregiverDetails') &&
				enrollmentCtxt.input.performer === PerformerConstants.caregiver && (
					<div className="flex flex-col gap-y-5">
						<div className="text-2xl">
							<RichText html={ctxt.json.pages.userProfile.informationTitle} />
						</div>
						<div className="mb-5">
							<PersonalInfo suffix={PerformerConstants.caregiver} />
						</div>
					</div>
				)}
			<ReviewGroup items={data} />
		</div>
	);
};
export default ContactInfo;
